import { IUserMilestone } from '../../IUserMilestone';

/**
 * Retailer has seen the vendor upload list info modal
 */
export const VENDOR_UPLOAD_LIST_MODAL_SEEN =
  'VENDOR_UPLOAD_LIST_MODAL_SEEN' as IUserMilestone.RetailerMilestone;
